<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div
            class="column is-three-fifths is-offset-one-fifth"
            v-if="iframeSrc !== ''"
          >
            <iframe
              scrolling="no"
              id="frame-reinit"
              width="100%"
              :src="iframeSrc"
            ></iframe>
          </div>
          <div
            class="column is-three-fifths is-offset-one-fifth"
            v-else-if="iframeSrc === '' && emailSent"
          >
            <b-notification :closable="false">
              {{ $t('viewResetPassword.label-5') }} <strong>{{ email }}</strong
              >.
              <br />
              {{ $t('viewResetPassword.label-6') }}
            </b-notification>
          </div>
          <div class="column is-three-fifths is-offset-one-fifth" v-else>
            <serveur-info :erreur="erreur" />
            <b-notification :closable="false">
              {{ $t('viewResetPassword.label-1') }}
              <br />
              {{ $t('viewResetPassword.label-2') }}
            </b-notification>
            <form @submit.prevent="validateBeforeSubmit">
              <b-notification :closable="false">
                <b-field
                  :label="$t('viewResetPassword.label-3') + ' *'"
                  :type="{ 'is-danger': errors.has('email') }"
                  :message="errors.first('email')"
                >
                  <b-input
                    name="email"
                    v-validate="'required|email'"
                    icon="envelope-open"
                    :placeholder="$t('viewResetPassword.label-3') + ' *'"
                    maxlength="190"
                    v-model="email"
                  ></b-input>
                </b-field>
              </b-notification>
              <nav class="level">
                <div class="level-left"></div>
                <div class="level-right">
                  <button
                    type="submit"
                    class="button is-primary"
                    :disabled="isDisabled()"
                  >
                    <span class="icon is-small"
                      ><i class="fa fa-paper-plane"></i
                    ></span>
                    <span>{{ $t('viewResetPassword.label-4') }}</span>
                  </button>
                </div>
              </nav>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import userService from '@/services/userService'
import ServeurInfo from '@/components/ServeurInfo.vue'

export default {
  name: 'ResetPassword',
  components: {
    'serveur-info': ServeurInfo
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      email: null,
      erreur: '',
      emailSent: false
    }
  },
  methods: {
    isDisabled: function () {
      return !this.email
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const loadingComponent = this.$buefy.loading.open({
            container: null
          })
          userService
            .userExists({
              email: this.email
            })
            .then((data) => {
              if (data.exists) {
                userService
                  .resetPassword({
                    email: this.email
                  })
                  .then((data) => {
                    loadingComponent.close()
                    this.emailSent = true
                  })
                  .catch((erreur) => {
                    loadingComponent.close()
                    this.erreur = erreur.response.data
                  })
              } else {
                loadingComponent.close()
                this.erreur = "Aucun compte associé à l'adresse Email saisie."
              }
            })
        }
      })
    }
  },
  computed: {
    iframeSrc: function () {
      let urlReturn = ''
      if (
        this.$route.params.id !== undefined &&
        this.$route.params.token !== undefined
      ) {
        urlReturn =
          '/accounts/reset/' +
          this.$route.params.id +
          '/' +
          this.$route.params.token +
          '/'
      }
      return urlReturn
    }
  }
}
</script>

<style lang="css">
#frame-reinit {
  height: 400px !important;
}
</style>
